import clsx from "clsx";
import { Spinner } from "../../../../../ui/molecules/spinner";
import Button from "../../../../../ui/molecules/button";
import { ArrowLeftIcon } from "../../../../../ui/icons/arrowLeft";
import { PlusIcon } from "../../../../../ui/icons/plus";
import { colors } from "../../../../../ui/colors";

export function NotSavedChangesModal({ visible, onClose, saveAction, goBackAction, loading }: { visible: boolean, onClose: () => void, saveAction: () => void, goBackAction: () => void, loading: boolean }) {
    return (
        <div
            onClick={() => onClose()}
            className={clsx(
                "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
                {
                    block: visible,
                    hidden: !visible,
                }
            )}
        >
            {loading ? (
                <Spinner />
            ) : (
                <div
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    className="transition-all relative flex flex-col items-center bg-white rounded-[12px] opacity-100 shadow-sm min-w-[400px]"
                >
                    <div
                        onClick={() => onClose()}
                        className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                    >
                        <PlusIcon color={colors.brandPrimary[600]} size={16} />
                    </div>
                    <div className="p-6 text-heading-xs font-semibold text-center">
                        Attenzione
                    </div>
                    <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
                        <span className="text-text-md font-normal text-neutral-600">
                            Hai delle modifiche non salvate. Vuoi continuare a modificare il dipendente?
                        </span>
                        <div className="w-full flex flex-1 gap-3">
                            <div className="w-1/2">
                                <Button
                                    fullWidth
                                    size={"sm"}
                                    iconPosition={"left"}
                                    icon={<ArrowLeftIcon color={""} size={0} />}
                                    variant={"outline"}
                                    color={"gray"}
                                    label="Torna alla lista"
                                    onClick={() => goBackAction()}
                                />
                            </div>
                            <div className="w-1/2">
                                <Button
                                    fullWidth
                                    size={"sm"}
                                    iconPosition={"off"}
                                    variant={"solid"}
                                    color={"blue"}
                                    label="Continua a modificare"
                                    onClick={() => saveAction()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}